module.exports = __webpack_public_path__ + "static/media/15.fd732b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/15.png
// module id = 974
// module chunks = 0